<p-confirmDialog />
<h3 class="with-manual-link">
  <span i18n="
  @@webhooks">Webhooks</span>
  <app-manual-link href="https://reflact.github.io/engine/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Skills/Webhooks"></app-manual-link>
</h3>
<p
  class="text-secondary mt-1 mb-1 "
  i18n="@@webhook-description"
>
  Konfiguriere externe HTTP-Endpunkte, die du im Scripting-Bereich manuell aufrufen kannst. Webhooks sind kein
  automatischer Bestandteil des LLM-Gesprächs.
</p>
<div class="mt-3">
  <div class="row">
    <div class="col-3">
      <span i18n="@@name">Name</span>
    </div>
    <div class="col">
      <input
        pInputText
        [(ngModel)]="this.customWebhookName"
        type="text"
        i18n-placeholder="@@name-webhook"
        placeholder="Name des Webhooks"
        fluid
        />
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-3">
      <span i18n="@@webhook-url">Webhook-URL</span>
    </div>
    <div class="col">
      <input
        pInputText
        [(ngModel)]="this.customWebhookUrl"
        type="url"
        i18n-placeholder="@@url"
        placeholder="URL"
        fluid
        #urlinput
        />
    </div>
  </div>
  <div class="row mt-2">
    <div class="col-3"></div>
    <div class="col-3">
      <div class="mb-3">
        <p-button
          (onClick)="this.addCustomWebhook()"
          icon="ri-add-line"
          label="Hinzufügen"
          i18n-label="@@add"
          size="small"
          [disabled]="this.customWebhookName.trim() === '' || this.customWebhookUrl.trim() === '' || !urlinput.checkValidity()"
          />
      </div>
    </div>
  </div>
</div>
<app-secret-placeholder-list></app-secret-placeholder-list>
@if (this.customWebhooks.length > 0) {
  <h5
    class="mt-5"
    i18n="@@webhooks-overview"
  >Webhooks im Überblick</h5>
}
@if (this.customWebhooks.length > 0) {
  <p-table
    dataKey="id"
    [(selection)]="selectedCustomWebhooks"
    [value]="this.customWebhooks"
    [rowHover]="true"
    styleClass="p-datatable-sm"
    >
    <ng-template pTemplate="header">
      <tr>
        <th class="bot-selection-cell"><p-tableHeaderCheckbox ariaLabel="Alle auswählen" i18n-ariaLabel="@@bulk-select-all" /></th>
        <th i18n="@@status">Status</th>
        <th i18n="@@name">Name</th>
        <th i18n="@@skillid">Skill ID</th>
        <th i18n="@@skill-usage-column">Stage-Zuordnung</th>
        <th i18n="@@onoff">Aus/An</th>
        <th i18n="@@actions">Aktionen</th>
      </tr>
    </ng-template>
    <ng-template
      pTemplate="body"
      let-custom
      >
      <tr class="align-middle">
        <td class="bot-selection-cell"><p-tableCheckbox [value]="custom" [ariaLabel]="custom.name" /></td>
        <td style="width: 4rem;">
          @for (i of [].constructor(this.skillService.getSkillDepth(custom.skillId)); track i; let idx = $index; let count = $count) {
            <i
              class="ri-corner-down-right-line text-secondary ms-2"
              [ngStyle]="{ 'opacity': idx === count - 1 ? 1 : 0 }"
            ></i>
          }
          @if (custom.enabled) {
            <i
              class="ri-circle-fill text-primary me-2"
            ></i>
          }
          @if (!custom.enabled) {
            <i
              class="ri-circle-line text-secondary me-2"
            ></i>
          }
        </td>
        <td>
          <span
            class="fakelink"
            (click)="showDetailDrawer(custom.id)"
            >
            {{ custom.name }}
          </span>
        </td>
        <td style="width:250px">
          <app-skill-id-input
            [value]="custom.skillId"
            [readonly]="false"
            (changed)="custom.skillId = $event; this.rss.saveBotConfigField('toolConfigs')"
          ></app-skill-id-input>
        </td>
        <td>
          <app-skill-usage-list [skillId]="custom.skillId"></app-skill-usage-list>
        </td>
        <td style="width: 0rem;">
          <p-toggleswitch
            [(ngModel)]="custom.enabled"
            (onChange)="this.rss.saveBotConfigField('toolConfigs')"
            />
        </td>
        <td
          style="width: 2rem;"
          class="text-end"
          >
          <p-menu
            #menu
            appendTo="body"
            [model]="customWebhookContextMenu"
            [popup]="true"
          ></p-menu>
          <p-button
            (onClick)="openCustomWebhookMenu($event, menu, custom)"
            [rounded]="true"
            [text]="true"
            severity="secondary"
            [raised]="true"
            icon="ri ri-more-2-fill"
          ></p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <app-bulk-action-bar [actions]="bulkActions" [count]="selectedCustomWebhooks.length" [allSelected]="allSelected"
    (selectAll)="toggleAll(true)" (clear)="selectedCustomWebhooks = []" />
}

@if (detailDrawer) {
  <p-drawer
    [(visible)]="this.detailDrawer"
    [position]="'right'"
    [modal]="true"
    [closeOnEscape]="true"
    styleClass="w-100 w-md-75 w-lg-50"
    >
    @if (this.selectedWebhookId) {
      <app-webhooks-tab-details
        [selectedWebhookId]="this.selectedWebhookId"
        (closeDrawer)="this.detailDrawer = false"
      ></app-webhooks-tab-details>
    }
  </p-drawer>
}
